import { useContext } from 'react';

import { HreflangContext } from '../providers/hreflang-provider';

export const useHreflang = () => {
  const context = useContext(HreflangContext);

  if (!context) {
    throw new Error('useHreflang must be used within a HreflangContextProvider');
  }

  return context;
};
